import React from 'react'
import { Boxes, PawPrint } from 'lucide-react'
import { DETECTOR_OPTIONS } from './detectorRegistry'
import { getAiCodeIcon } from '../aiCodeIcons'
import styles from './Vision.module.css'

// Reuse the same icons as the /ai-code Select-Feature screen so the play mode
// reads as the same product. count/pet have no A.I.-code feature of their own,
// so they borrow a close lucide icon.
const ICON_FOR = {
    face: getAiCodeIcon('ai', 'face'),
    object: getAiCodeIcon('ai', 'object'),
    tracking: getAiCodeIcon('ai', 'tracking'),
    count: Boxes,
    gesture: getAiCodeIcon('ai', 'hand'),
    pet: PawPrint,
    color: getAiCodeIcon('ai', 'colour'),
    marker: getAiCodeIcon('ai', 'marker'),
    ocr: getAiCodeIcon('ai', 'ocr'),
    speech: getAiCodeIcon('ai', 'voice'),
    motion: getAiCodeIcon('ai', 'motion'),
}

const shortLabel = (label) => label.replace(/\s*Detection$/i, '')

// Horizontal, minimal detection picker pinned to the bottom of the play screen —
// one small card per detection, active card highlighted with its accent colour.
const DetectionBar = ({ activeId, onSelect }) => (
    <div className={styles.detectBar}>
        <div className={styles.detectStrip}>
            {DETECTOR_OPTIONS.map((opt) => {
                const Icon = ICON_FOR[opt.id]
                const active = opt.id === activeId
                return (
                    <button
                        key={opt.id}
                        type="button"
                        className={`${styles.detectItem} ${
                            active ? styles.detectItemActive : ''
                        }`}
                        style={active ? { borderColor: opt.accent } : undefined}
                        onClick={() => onSelect(opt.id)}
                        title={opt.label}
                    >
                        <span
                            className={styles.detectIcon}
                            style={active ? { color: opt.accent } : undefined}
                        >
                            {Icon && <Icon width={22} height={22} />}
                        </span>
                        <span className={styles.detectLabel}>
                            {shortLabel(opt.label)}
                        </span>
                        {opt.comingSoon && (
                            <span className={styles.detectSoon}>soon</span>
                        )}
                    </button>
                )
            })}
        </div>
    </div>
)

export default DetectionBar
